import { Res } from 'core/api';
import { Result, SessionProvider } from 'core/infrastructure';
import { Command } from 'pos/common';
import * as SalesStore from '../SalesStore';
import { DeliveryNoteFacade } from 'pos/facades';
import { blockTicketWhileClosing, makeTicketReadyToClose } from 'pos/modules/helpers/document-creation';
import { Toaster } from 'core/ui-next';
import { Message } from 'core/ui-next/modal';

declare global {
	interface CommandType {
		createInternalConsumption: () => Promise<Result>;
	}
}

Command.register('createInternalConsumption', 'NO_PRECONDITION', async (): Promise<Result> => {

	if (SalesStore.getTicket().IsEmpty) {
		await Message.show(Res.Msg.MSG_TICKET_IS_EMPTY());
		return Result.error();
	}

	const customerType = SessionProvider.getCurrent().InternalConsumptionCustomerType;

	if (!customerType) {
		Toaster.warn(Res.Msg.MSG_INTERNAL_CONSUMPTIONS_NO_CUSTOMER_TYPE());
		return Result.error();
	}

	const customerResult = await Command.execute('searchCustomerByType', customerType);
	if (customerResult.ok) {

		await blockTicketWhileClosing(SalesStore.getTicket().Id, async () => {
			await SalesStore.setCustomer(customerResult.value);

			const draft = await DeliveryNoteFacade.getDraftByTicketId(SalesStore.getTicket().Id);
			const ticketReadyResult = await makeTicketReadyToClose({
				getTicket: SalesStore.getTicket,
				setFriendlyName: SalesStore.setFriendlyName,
				setTableCompanions: SalesStore.setTableCompanions,
				closeAs: 'DeliveryNote'
			});

			if (!ticketReadyResult.ok)
				return Result.error(ticketReadyResult.error);

			const createDeliveryNoteResult = await SalesStore.createDeliveryNote({
				Reason: Res.Web.INTERNAL_CONSUMPTION_DELIVERY_NOTE_REASON(),
				ShouldPrint: false,
				Payments: [],
				PrepayAmount: 0,
				DeliveryAddress: {
					City: '',
					Region: '',
					Street: '',
					ZipCode: ''
				},
				DraftSerialNumber: draft.SerialNumber,
				IsRefund: false,
				CustomerDocumentNumber: '',
				RelatedSalesOrders: [],
				InvoiceCanBeEmitted: false
			});

			if (!createDeliveryNoteResult.ok)
				return Result.error(createDeliveryNoteResult.error);

			return Result.ok();
		});
	}

	return Result.ok();
});